import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ script, title, description, keywords, canonicalUrl,children }) => {
    return (
        <Helmet>
            {/* <script></script> commented */}
            <title>{title}</title>
            <meta name="title" content={title} data-react-helmet="true"/>
            <meta charSet="utf-8" />
            {description ? <meta name="description" content={description} /> : null}
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={canonicalUrl} />
            {children}
        </Helmet>
    )
}

export default Meta


